"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26699],{

/***/ 26699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1591);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49161);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8920);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63457);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82285);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80797);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_Info__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(18362);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(86010);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16502);
/* harmony import */ var _Shop_Price__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31907);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94455);









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        productCard: _defineProperty({
            minHeight: 70
        }, theme.breakpoints.down('md'), {
            font: '12px'
        }),
        productCardConfirmationPage: _defineProperty({
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(1),
            marginBottom: theme.spacing(2)
        }, theme.breakpoints.up('md'), {
            justifyContent: 'space-between',
            width: '100%'
        }),
        checkBox: {},
        imgContainer: {
            height: 60
        },
        imgContainerConfirmationPage: _defineProperty({
            width: 85,
            height: 85,
            position: 'relative',
            marginRight: theme.spacing(1)
        }, theme.breakpoints.up('md'), {
            marginRight: theme.spacing(2),
            width: 50,
            height: 50
        }),
        imgProduct: _defineProperty({
            height: '100%',
            objectFit: 'contain'
        }, theme.breakpoints.down('md'), {
            marginLeft: theme.spacing(0)
        }),
        imgProductConfirmationPage: _defineProperty({
            width: '100%',
            objectFit: 'contain',
            marginLeft: theme.spacing(0)
        }, theme.breakpoints.up('md'), {}),
        productInformationConfirmationPage: _defineProperty({
            width: '-webkit-fill-available',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around'
        }, theme.breakpoints.up('md'), {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between'
        }),
        productName: _defineProperty({
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(1)
        }, theme.breakpoints.up('md'), {
            marginLeft: theme.spacing(2),
            width: '80%',
            padding: theme.spacing(2)
        }),
        productNameConfirmationPage: _defineProperty({
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            marginLeft: theme.spacing(2)
        }, theme.breakpoints.up('md'), {
            width: '80%'
        }),
        productNameString: _defineProperty({
            paddingRight: theme.spacing(1)
        }, theme.breakpoints.down('md'), {
            fontSize: 11
        }),
        productNameStringConfirmationPage: {
            paddingRight: theme.spacing(2)
        },
        productNotEligibleToReturn: _defineProperty({
            fontSize: 13
        }, theme.breakpoints.down('md'), {
            fontSize: 11
        }),
        informationIcon: {
            fontSize: 13,
            marginLeft: theme.spacing(0.5)
        },
        productQuantity: {
            width: '10%'
        },
        productQuantityConfirmationPage: {
            width: '15%'
        },
        smallerText: (_obj = {
            fontSize: 13
        }, _defineProperty(_obj, theme.breakpoints.down('md'), {
            fontSize: 10
        }), _defineProperty(_obj, "whiteSpace", 'nowrap'), _obj),
        priceMonth: {
            width: '30%'
        },
        priceMonthConfirmationPage: {
            paddingLeft: theme.spacing(2)
        }
    });
});
var MainTooltip = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(theme) {
    return {
        tooltip: {
            textAlign: 'center',
            padding: theme.spacing(1),
            lineHeight: 1,
            '&:hover, &:focus': {
                cursor: 'default'
            }
        }
    };
})(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP);
var OrderProductRow = function(param) {
    var isModifying = param.isModifying, isSelected = param.isSelected, showSizes = param.showSizes, handleProductSelection = param.handleProductSelection, item = param.item, t = param.t, settings = param.settings, puid = param.puid, _isReturned = param.isReturned, isReturned = _isReturned === void 0 ? false : _isReturned, isConfirmation = param.isConfirmation, _isBought = param.isBought, isBought = _isBought === void 0 ? false : _isBought, index = param.index, _showQuantity = param.showQuantity, showQuantity = _showQuantity === void 0 ? true : _showQuantity, orderNumber = param.orderNumber, warehouseId = param.warehouseId, unit = param.unit, carrierId = param.carrierId, orderToken = param.orderToken, showPrice = param.showPrice, doc = param.doc, currency = param.currency;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var classes = useStyles();
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var isSmallScreen = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(theme.breakpoints.down('sm'));
    var displayFlexPrice = settings === null || settings === void 0 ? void 0 : settings.display_flex_price_a_day;
    var isDisabled = (item === null || item === void 0 ? void 0 : (ref = item.units) === null || ref === void 0 ? void 0 : ref.length) > 0 ? dayjs__WEBPACK_IMPORTED_MODULE_2___default()().isBefore((ref1 = item === null || item === void 0 ? void 0 : item.units[0]) === null || ref1 === void 0 ? void 0 : ref1.startLeasingDate) : true;
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showTooltip = ref17[0], setShowTooltip = ref17[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: !isConfirmation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            container: true,
            direction: "row",
            alignItems: "center",
            className: classes.productCard,
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    sm: 1,
                    xs: 1,
                    className: classes.checkBox,
                    alignItems: "center",
                    children: isModifying && !isReturned && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        direction: "right",
                        in: true,
                        mountOnEnter: true,
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            checked: isSelected,
                            onChange: function() {
                                return handleProductSelection(item.variant.sku, displayFlexPrice ? item.unitPrice : item.total / (item === null || item === void 0 ? void 0 : item.quantity), index, 1, orderToken ? orderToken : item === null || item === void 0 ? void 0 : item.token, item, orderNumber, warehouseId, carrierId);
                            },
                            name: item.variant.product.name,
                            "data-testid": "order__checkbox--".concat(index),
                            disabled: isDisabled
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    sm: 1,
                    xs: 2,
                    style: {
                        justifyContent: 'center',
                        display: 'flex'
                    },
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (ref3 = (ref2 = item.variant.product) === null || ref2 === void 0 ? void 0 : ref2.images[0]) === null || ref3 === void 0 ? void 0 : ref3.thumb,
                        alt: item.variant.product.name,
                        width: 40,
                        className: classes.imgProduct
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    sm: 10,
                    xs: 9,
                    style: {
                        justifyContent: 'left',
                        display: 'flex'
                    },
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            sm: 1,
                            className: classes.productQuantity,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                variant: 'body2',
                                children: [
                                    "x ",
                                    item.quantity
                                ]
                            })
                        }),
                        isSmallScreen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            xs: 6,
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                variant: 'h5',
                                className: classes.productNameString,
                                children: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .truncateString */ .aS)(item.variant.product.name, 24)
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            sm: 6,
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                variant: 'h5',
                                children: [
                                    item.variant.product.name,
                                    showQuantity && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        variant: 'caption',
                                        children: [
                                            "\xa0x\xa0",
                                            item === null || item === void 0 ? void 0 : item.quantity
                                        ]
                                    })
                                ]
                            })
                        }),
                        showSizes && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            sm: 3,
                            xs: 3,
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                variant: 'body2',
                                children: [
                                    t('texts:subscription_order:size'),
                                    ' ',
                                    item === null || item === void 0 ? void 0 : (ref4 = item.variant) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.newSize) === null || ref5 === void 0 ? void 0 : ref5.name
                                ]
                            })
                        }),
                        puid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            sm: 2,
                            xs: 2,
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                variant: 'body2',
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("small", {
                                    children: [
                                        "Code:\xa0",
                                        puid
                                    ]
                                })
                            })
                        }),
                        unit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            sm: 2,
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                variant: 'caption',
                                children: [
                                    t('texts:subscription_order:returned_date'),
                                    "\xa0",
                                    dayjs__WEBPACK_IMPORTED_MODULE_2___default()(unit === null || unit === void 0 ? void 0 : unit.endLeasingDate).format('L')
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            sm: 2,
                            xs: 2,
                            children: !displayFlexPrice && showPrice && "date_to_date" !== 'classic_subscription' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                variant: 'body2',
                                className: classes.smallerText,
                                children: isReturned || isBought ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shop_Price__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    amount: item.total / item.quantity,
                                    showDayOrMonth: false,
                                    buyAble: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .isPurchasedItem */ .mo)(item),
                                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                    isShort: false,
                                    displayFlexPrice: false,
                                    showUnitText: item.quantity > 1,
                                    UnitText: settings === null || settings === void 0 ? void 0 : settings.config_unit_text,
                                    currency: currency
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shop_Price__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    amount: item.unitPrice,
                                    showDayOrMonth: true,
                                    buyAble: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .isPurchasedItem */ .mo)(item),
                                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                    isShort: false,
                                    displayFlexPrice: displayFlexPrice,
                                    showUnitText: item.quantity > 1,
                                    UnitText: settings === null || settings === void 0 ? void 0 : settings.config_unit_text,
                                    currency: currency
                                })
                            })
                        }),
                        isModifying && !isReturned && isDisabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            sm: 4,
                            xs: 1,
                            className: classes.productNotEligibleToReturn,
                            children: [
                                !isSmallScreen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.product_not_eligible_for_return,
                                    defaultText: t('texts:subscription_order:product_not_eligible_for_return')
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MainTooltip, {
                                    title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.tooltip_product_not_eligible_for_return,
                                        defaultText: t('texts:subscription_order:tooltip_product_not_eligible_for_return')
                                    }),
                                    placement: "bottom",
                                    open: showTooltip,
                                    enterDelay: 2000,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        onMouseEnter: function() {
                                            return setShowTooltip(true);
                                        },
                                        onMouseLeave: function() {
                                            return setShowTooltip(false);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Info__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            className: classes.informationIcon
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(classes.productCard, isConfirmation && classes.productCardConfirmationPage),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: isConfirmation ? classes.imgContainerConfirmationPage : classes.imgContainer,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (ref9 = item === null || item === void 0 ? void 0 : (ref8 = item.product) === null || ref8 === void 0 ? void 0 : ref8.images[0]) === null || ref9 === void 0 ? void 0 : ref9.cachedPath,
                        alt: item === null || item === void 0 ? void 0 : (ref10 = item.product) === null || ref10 === void 0 ? void 0 : ref10.name,
                        className: isConfirmation ? classes.imgProductConfirmationPage : classes.imgProduct
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: isConfirmation && classes.productInformationConfirmationPage,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: isConfirmation ? classes.productNameConfirmationPage : classes.productName,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: isConfirmation && isSmallScreen ? classes.productQuantityConfirmationPage : classes.productQuantity,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        variant: 'body2',
                                        children: [
                                            "x ",
                                            item.quantity
                                        ]
                                    })
                                }),
                                isSmallScreen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'h5',
                                    className: isConfirmation && isSmallScreen ? classes.productNameStringConfirmationPage : classes.productNameString,
                                    children: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .truncateString */ .aS)(item.product.name, 24)
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'h5',
                                    children: item.product.name
                                }),
                                showSizes && !item.product.isSimpleProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'body2',
                                    children: [
                                        t('texts:subscription_order:size'),
                                        "\xa0",
                                        (ref12 = item === null || item === void 0 ? void 0 : (ref11 = item.product) === null || ref11 === void 0 ? void 0 : ref11.variants[0]) === null || ref12 === void 0 ? void 0 : ref12.size
                                    ]
                                }),
                                puid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'body2',
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("small", {
                                        children: [
                                            "Code:\xa0",
                                            puid
                                        ]
                                    })
                                }),
                                unit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'caption',
                                    children: [
                                        t('texts:subscription_order:returned_date'),
                                        "\xa0",
                                        unit.endLeasingDate
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: isConfirmation ? classes.priceMonthConfirmationPage : classes.priceMonth,
                            children: showPrice && "date_to_date" !== 'classic_subscription' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                variant: 'body2',
                                className: classes.smallerText,
                                children: (item === null || item === void 0 ? void 0 : item.totalWithoutPromotion) && !isConfirmation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shop_Price__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    amount: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .isPurchasedItem */ .mo)(item) ? item.unitPrice : item.totalWithoutPromotion,
                                    showDayOrMonth: true,
                                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                    buyAble: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .isPurchasedItem */ .mo)(item),
                                    isShort: false,
                                    displayFlexPrice: displayFlexPrice,
                                    showUnitText: item.quantity > 1,
                                    UnitText: settings === null || settings === void 0 ? void 0 : settings.config_unit_text,
                                    currency: currency
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Shop_Price__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    amount: ((ref14 = item === null || item === void 0 ? void 0 : (ref13 = item.product) === null || ref13 === void 0 ? void 0 : ref13.variants[0].price) === null || ref14 === void 0 ? void 0 : ref14.current) ? ((ref16 = item === null || item === void 0 ? void 0 : (ref15 = item.product) === null || ref15 === void 0 ? void 0 : ref15.variants[0].price) === null || ref16 === void 0 ? void 0 : ref16.current) * item.quantity : item.total,
                                    showDayOrMonth: true,
                                    buyAble: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .isPurchasedItem */ .mo)(item),
                                    dayOrMonth: settings === null || settings === void 0 ? void 0 : settings.day_or_month,
                                    isShort: false,
                                    displayFlexPrice: displayFlexPrice,
                                    showUnitText: item.quantity > 1,
                                    UnitText: settings === null || settings === void 0 ? void 0 : settings.config_unit_text,
                                    currency: currency
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (OrderProductRow);


/***/ })

}]);